import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "Icon",
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.65.667C4.134.667.47 4.302.47 8.786c0 1.534.428 2.968 1.173 4.192L.167 17.333l4.53-1.439a8.203 8.203 0 0 0 3.954 1.01c4.52 0 8.182-3.635 8.182-8.119S13.17.667 8.651.667Zm0 14.877a6.812 6.812 0 0 1-3.746-1.118l-2.618.832.85-2.51A6.685 6.685 0 0 1 1.84 8.785c.001-3.727 3.056-6.759 6.812-6.759 3.756 0 6.812 3.032 6.812 6.759 0 3.727-3.056 6.759-6.812 6.759Zm3.837-4.914c-.206-.111-1.213-.65-1.402-.727-.189-.076-.327-.116-.474.086-.146.203-.565.654-.691.788-.127.133-.25.146-.455.034-.205-.111-.87-.355-1.641-1.09-.6-.573-.993-1.267-1.107-1.478-.114-.213 0-.32.107-.42.097-.09.218-.234.327-.351.108-.117.147-.202.222-.338.074-.135.044-.257-.004-.363-.049-.106-.428-1.14-.586-1.563-.158-.42-.335-.358-.457-.363-.122-.004-.26-.027-.4-.032a.768.768 0 0 0-.566.239c-.2.2-.758.681-.797 1.701-.038 1.02.673 2.033.772 2.175.1.142 1.358 2.352 3.45 3.26 2.092.91 2.102.632 2.486.612.384-.02 1.254-.455 1.447-.933.192-.477.207-.892.159-.98-.049-.088-.186-.146-.39-.257Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      transform: "translate(.167 .667)",
      d: "M0 0h16.667v16.667H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }